/* eslint-disable @typescript-eslint/no-this-alias */
import { computed, inject, Injectable } from '@angular/core';
import { Auth, User } from '@angular/fire/auth';
import { AuthState, WINDOW } from 'moddy/common';
import { AppUserService } from './app-user.service';

let service: AuthService;

export function isAuthorized(): boolean {
    return service.isAuthorized();
}

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public readonly isAuthorized = computed(() => !!this.userService.data());

    private readonly fireAuth = inject(Auth);
    private readonly authState = inject(AuthState);
    private readonly userService = inject(AppUserService);
    private readonly window = inject(WINDOW);

    constructor() {
        service = this;
    }

    public init(): Promise<User | null> {
        return new Promise((resolve) => {
            this.fireAuth.onAuthStateChanged(async (user) => {
                const isBecomeUnauth = !!this.authState.value() && !user;

                this.authState.set(user);

                if (user) {
                    this.userService.initObserver();
                } else if (isBecomeUnauth) {
                    // Reload the page to run guards in the current route context
                    this.window.location.reload();
                }

                await this.userService.update();

                resolve(user);
            });
        });
    }

    public async logout(): Promise<void> {
        await this.fireAuth.signOut();
    }
}
